module.exports = __webpack_public_path__ + "media/images/common/support1-44bc073816230fd3ac87a952ee0c10e8.png";